/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {LogFrameModel} from '../../core/_models'

type Props = {
  logFrame: LogFrameModel
}

const LogFrameDescriptionCell: FC<Props> = ({logFrame}) => {

  return(
  <div className='d-flex align-items-center'>
    <div className='d-flex flex-column'>
      <a  className='text-gray-800 text-hover-primary mb-1'>
        {logFrame.description}
      </a>
      
    </div>
  </div>     

)}
export {LogFrameDescriptionCell}
